module.exports = __webpack_public_path__ + "img/databind.138bfa89.png";